import "core-js/modules/es.array.push.js";
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render: function render(h, context) {
    var _context$props = context.props,
      icon = _context$props.icon,
      title = _context$props.title;
    var vnodes = [];

    // if (icon) {
    //   vnodes.push(<svg-icon icon-class={icon}/>)
    // }

    if (title) {
      vnodes.push(h("span", {
        "style": 'font-size: 14px!important',
        "slot": 'title'
      }, [title]));
    }
    return vnodes;
  }
};